import React, { useEffect, useLayoutEffect, useState } from 'react';
import { PricingType, TProduct, TProductTag, TSaleProduct, TSaleSet, TShoppingCart } from '../constants/types';
import { Filters } from '../services/Globals';

export function openTab(url : string) {
  const a = document.createElement("a");
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.click();
}

export function getFilteredProducts(_cards : TProduct[], filter: string = Filters.PriceUp) : TProduct[] {
  switch (filter) {
      case Filters.PriceUp: 
          _cards.sort((a,b) => a.priceInEUR < b.priceInEUR ? 1 : -1);
          break;
      case Filters.PriceDown: 
          _cards.sort((a,b) => a.priceInEUR > b.priceInEUR ? 1 : -1);
          break;
      case Filters.Product2ndFilterUp: 
          _cards.sort((a,b) => a.title < b.title ? -1 : 1);
          break;
      case Filters.Product2ndFilterDown: 
          _cards.sort((a,b) => a.title > b.title ? -1 : 1);
          break;
      default:
          break;
  }
  return _cards;
}

export function generateSetUrl(product: TProduct) : string {
  return `${window.location.origin}/set/${product.name}`;  
}

export function generateProductUrl(product: TProduct) : string {
  return `${window.location.origin}/Product/${product.name} - ${product.title} - ${product.id}`;
}

export function IPAddress() {
  return fetch('https://api.ipify.org?format=json')
      .then(response => response.json())
      .then(data => data.ip)
      .catch(error => console.log(error));
}

export function GetSendCost(shoppingcart: TShoppingCart, DevEnabled: boolean) : Promise<number> {
  return new Promise((resolve,reject) => {
    if (shoppingcart.items.length) {
      let productids: TSaleProduct[] = [];
      let setids: TSaleSet[] = [];
      shoppingcart.items.forEach(item => {
          for (let i = 0; i < item.ammount; i++) {
              if (item.set) {
                  setids.push({id: item.set.id});
              } else {
                  productids.push({ id: item.product.id, setid: item.product.isProduct ? -1 : item.product.setID, ammount: item.ammount });
              }
          }
      });
      let sale = {products: productids, sets: setids}

      let hostUrl = `${window.location.origin}/Backend`;
      if (DevEnabled) {
          hostUrl = process.env.REACT_APP_DEV_API_URL;
      }
      fetch(`${hostUrl}/GetSendCost`, {
          method: "Post", 
          mode: "cors", 
          headers: {
              "Accept": "application/json",
              "Content-Type": "application/json",
              "Accept-Encoding": "gzip, deflate ,br"
          },
          referrerPolicy: "origin-when-cross-origin", 
          body: JSON.stringify(sale), 
      }).then((response) => response.json()).then((rtn:number) => {
          if (rtn > 0) {
            resolve(rtn);
          } else {
            reject();
          }
      });
    } else {
      reject();
    }
  });
}

export function CalculatePrices(satprice: number, sendcost: number, shoppingcart:TShoppingCart, BitcoinEnabled: boolean) : [number,number,number]{
  let total = 0;
  let itemCount = 0;
  if (BitcoinEnabled) {
    shoppingcart?.items.forEach(item => {
        itemCount = itemCount + item.ammount;
        total = total + item.ammount * (item.product.priceInEUR / satprice);
    });
    total += sendcost;
  } else {
    shoppingcart?.items.forEach(item => {
        if (item.set) {
          itemCount++;
          total += item.discountedPrice;
        } else {
          itemCount = itemCount + item.ammount;
          total = total + (item.ammount * item.product.priceInEUR);
        }
    });
    total += sendcost;
  }

  return [total, sendcost, itemCount];
}

export function calculateProductBTCPrice(product: TProduct, satprice: number, eurprice: number) {
  switch (product.pricedIn) {
      case PricingType.EUR:
          product.priceInUSD = product.priceInEUR / eurprice;
          break;
      case PricingType.USD:
          break;
      default:
          break;
  }
  product.priceInSats = Math.round(product.priceInUSD / satprice);
  return product;
}

export function ProcessProducts(prods) : TProduct[]  {
  //console.log({prods});
  let products: TProduct[] = [];
  prods.forEach(prod => {
      //console.log({prod});
      let imgUrls : string[] = [];
      if (prod?.imageNames) {
        prod.imageNames.split(',').forEach(imgUrl => {
            imgUrls.push(process.env.PUBLIC_URL + `/assets/products/${prod.setID}/${prod.id}/${imgUrl}`);
        });
      }
      let tags: TProductTag[] = [];
      prod.tags.forEach(tag => {
          tags.push({key: tag.title, value: tag.value});
      });

      products.push({
          isProduct: prod.isproduct,
          available: prod.available,
          description: prod.description,
          id: prod.id,
          order: prod.order,
          priceInEUR: prod.priceineur,
          title: prod.title,
          priceInUSD: prod.priceinusd,
          name: prod.name,
          priceInSats: 0, 
          tags: tags, 
          imageUrls: imgUrls, 
          pricedIn: PricingType.EUR,
          setID: prod.setid,
          showInSets: prod.showinsets
      });
  });
  
  products.sort((a,b) => a.order < b.order ? -1 : 1);
  products.sort((a,b)=> a.available > b.available ? -1 : 1);
  //console.log({products});
  return products;
}